import React, { FC, useEffect, useState } from 'react'
import { Menu, MenuList } from '@chakra-ui/react'
import { DropdownButton } from './dropdown-button'
import { DropdownItem } from './dropdown-item'

export interface DropdownProps {
  options: Array<{
    value: string
    label: string
  }>
  onChange?: (value: string) => void
  placeholder?: string
  /**
   * Current value that should be displayed. Makes the component controlled by
   * its parent, which in turn means you _will_ need to implement `onChange`.
   */
  value?: string
  stretch?: boolean
  excludeSelected?: boolean
}

export const Dropdown: FC<DropdownProps> = ({
  placeholder,
  options,
  onChange,
  value,
  stretch,
  excludeSelected = false,
}) => {
  const [label, setLabel] = useState<string>(placeholder || options[0].label)

  useEffect(() => {
    if (value) {
      const selectedOption = options.find(({ value: optionValue }) => value === optionValue)

      setLabel(selectedOption ? selectedOption.label : value)
    }
  }, [value, options])

  return (
    <Menu>
      <DropdownButton label={label} stretch={stretch} />
      <MenuList
        borderRadius="medium"
        boxShadow="md"
        border="1px solid"
        borderColor="grey"
        color="black"
        padding={2}
        width={240}
        zIndex="popover"
        maxHeight={72}
        backgroundColor="white"
        tabIndex={0}
        _focus={{
          borderColor: 'brand',
          boxShadow: '0 0 0 2px #5bce4c',
        }}
        aria-label={`menu-${label}`}
      >
        {(excludeSelected ? options.filter((option) => option.label !== label) : options).map((option) => (
          <DropdownItem
            itemValue={option.value}
            label={option.label}
            key={`option-${option.value}`}
            onClick={() => {
              onChange && onChange(option.value)

              if (!value) {
                setLabel(option.label)
              }
            }}
          />
        ))}
      </MenuList>
    </Menu>
  )
}
